import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideHash = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 9h16M4 15h16M10 3 8 21m8-18-2 18"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLucideHash);
const Memo = memo(ForwardRef);
export default Memo;
